(() => {
  if (window.SafeWalkV7KachingNativeContract) return;

  const KACHING = '__kaching_bundles';
  const MODE = 'personalized_real_gifts';
  const KINDS = ['harness_only', 'harness_bungee', 'full_set'];
  const ROLES = ['gift_tags', 'gift_dispenser', 'gift_roll'];
  const copy = () => window.SafeWalkV6RealGiftCopy || {};
  const dogProperty = () => copy().dogNameProperty || 'שם הכלב';
  const phoneProperty = () => copy().phoneProperty || 'מספר טלפון';
  const propertiesFor = (item) => item?.properties && typeof item.properties === 'object'
    ? item.properties
    : {};
  const metadataFor = (item) => {
    const raw = propertiesFor(item)[KACHING];
    if (!raw) return null;
    if (typeof raw === 'object') return raw;
    const candidates = [String(raw)];
    try {
      if (typeof window.atob === 'function') candidates.push(window.atob(String(raw)));
    } catch (error) { /* not base64; use the original value */ }
    for (const candidate of candidates) {
      try {
        const parsed = JSON.parse(candidate);
        if (parsed && typeof parsed === 'object') return parsed;
      } catch (error) { /* try the next supported Kaching encoding */ }
    }
    return null;
  };
  const lineTotal = (item) => Number.isFinite(Number(item?.final_line_price))
    ? Number(item.final_line_price)
    : Number(item?.final_price || 0) * Number(item?.quantity || 1);
  const originalTotal = (item) => Number.isFinite(Number(item?.original_line_price))
    ? Number(item.original_line_price)
    : Number(item?.original_price || 0) * Number(item?.quantity || 1);
  const variantId = (item) => Number(item?.variant_id || item?.id || 0);
  const productId = (item) => Number(item?.product_id || item?.product?.id || 0);
  const parentKey = (item) => String(
    item?.parent_relationship?.parent_key
      || item?.parent_relationship?.parent?.key
      || ''
  );
  const validationKey = ({ phone } = {}) => {
    const value = String(phone || '').trim();
    if (!value) return '';
    const digits = value.replace(/\D/g, '');
    return digits.length >= 7 && digits.length <= 15 ? '' : 'phoneError';
  };
  const identityFor = (config, role) => (config.identities || [])
    .find((identity) => identity.role === role);
  const itemMatchesIdentity = (item, identity) => Boolean(identity)
    && productId(item) === Number(identity.productId)
    && variantId(item) === Number(identity.variantId);
  const completeGiftIds = (ids = {}) => ROLES.every((role) => Boolean(ids[role]))
    && new Set(ROLES.map((role) => ids[role])).size === ROLES.length;
  const validateConfig = (config = {}) => {
    if ((config.mode || MODE) !== MODE) return true;
    const identities = config.identities || [];
    const identitiesValid = identities.length === ROLES.length
      && ROLES.every((role) => identities.filter((item) => item.role === role).length === 1)
      && identities.every((item) => Number(item.productId) > 0 && Number(item.variantId) > 0)
      && new Set(identities.map((item) => Number(item.productId))).size === ROLES.length
      && new Set(identities.map((item) => Number(item.variantId))).size === ROLES.length;
    return identitiesValid
      && Number(config.qualifyingProductId) > 0
      && Boolean(config.deal)
      && KINDS.every((kind) => Boolean(config.bars?.[kind])
        && completeGiftIds(config.realGiftIds?.[kind]));
  };
  const readRootConfig = (root) => {
    const identity = (role, prefix) => ({
      role,
      productId: Number(root?.dataset[`${prefix}ProductId`] || 0),
      variantId: Number(root?.dataset[`${prefix}VariantId`] || 0)
    });
    const giftIds = (prefix) => ({
      gift_tags: root?.dataset[`${prefix}TagGiftId`] || '',
      gift_dispenser: root?.dataset[`${prefix}DispenserGiftId`] || '',
      gift_roll: root?.dataset[`${prefix}RollGiftId`] || ''
    });
    return {
      mode: root?.dataset.giftMode || window.SafeWalkV6GiftMode,
      currentProductId: Number(root?.dataset.currentProductId || 0),
      qualifyingProductId: Number(root?.dataset.realQualifyingProductId || 0),
      deal: root?.dataset.kachingDealId || '',
      bars: {
        harness_only: root?.dataset.kachingP1BarId || '',
        harness_bungee: root?.dataset.kachingP2BarId || '',
        full_set: root?.dataset.kachingP3BarId || ''
      },
      identities: [
        identity('gift_tags', 'realTagGift'),
        identity('gift_dispenser', 'realDispenserGift'),
        identity('gift_roll', 'realRollGift')
      ],
      realGiftIds: {
        harness_only: giftIds('kachingP1'),
        harness_bungee: giftIds('kachingP2'),
        full_set: giftIds('kachingP3')
      }
    };
  };
  const configFromRoot = (root) => {
    const base = readRootConfig(root);
    const kind = root?.swv5Purchase?.getPackageState?.()?.kind || 'harness_only';
    return {
      ...base,
      kind,
      barId: base.bars[kind] || '',
      giftIds: base.realGiftIds[kind] || {}
    };
  };
  const configFromRegistry = () => {
    const registry = window.SafeWalkV6RealGiftRegistry || {};
    return {
      ...registry,
      currentProductId: Number(registry.qualifyingProductId || 0)
    };
  };
  const kindForMetadata = (metadata, config) => {
    if (!metadata || metadata.deal !== config.deal || metadata.main !== true) return '';
    if (metadata.bid === config.bars?.harness_only) return 'harness_only';
    if (metadata.bar === config.bars?.harness_bungee) return 'harness_bungee';
    if (metadata.bar === config.bars?.full_set) return 'full_set';
    return '';
  };
  const legacyKindForMetadata = (metadata, config) => {
    const legacy = config.legacy || {};
    if (!metadata || metadata.deal !== legacy.deal || metadata.main !== true) return '';
    if (metadata.bid === legacy.bars?.harness_only) return 'harness_only';
    if (metadata.bar === legacy.bars?.harness_bungee) return 'harness_bungee';
    if (metadata.bar === legacy.bars?.full_set) return 'full_set';
    return '';
  };
  const linkedToMain = (item, main) => {
    const key = parentKey(item);
    if (key) return key === String(main?.key || '');
    if (Number(item?.parent_id || 0)) return Number(item.parent_id) === variantId(main);
    return String(metadataFor(item)?.id || '') === String(metadataFor(main)?.id || '');
  };
  const legacyFingerprintFor = (item, config) => {
    const legacy = config.legacy || {};
    const metadata = metadataFor(item);
    const dispenserIdentity = identityFor(config, 'gift_dispenser');
    if (!metadata || metadata.deal !== legacy.deal || !metadata.id) return null;
    const mainKind = legacyKindForMetadata(metadata, config);
    if (metadata.main === true) {
      return KINDS.includes(mainKind)
        && productId(item) === Number(config.qualifyingProductId)
        && Number(item.quantity) === 1
        && lineTotal(item) > 0
        ? { role: 'main', kind: mainKind }
        : null;
    }
    const giftKind = KINDS.find((kind) => metadata.gift === legacy.giftIds?.[kind]);
    if (giftKind && itemMatchesIdentity(item, dispenserIdentity)
      && Number(item.quantity) === 1 && originalTotal(item) > 0) {
      return { role: 'gift', kind: giftKind };
    }
    const bundleKind = KINDS.find((kind) => (
      metadata.bar === legacy.bars?.[kind]
      && legacy.bundleIds?.[kind]?.includes(metadata.bundleProduct)
    ));
    return bundleKind && Number(item.quantity) === 1 && lineTotal(item) > 0
      ? { role: 'bundle', kind: bundleKind, entry: metadata.bundleProduct }
      : null;
  };
  const classifyLegacy = (items, config) => {
    const legacy = config.legacy || {};
    if (!legacy.deal || !identityFor(config, 'gift_dispenser')) {
      return { groups: [], orphanGroups: [], invalidGroups: [], invalidItems: [] };
    }
    const legacyItems = items.filter((item) => metadataFor(item)?.deal === legacy.deal);
    const invalidItems = legacyItems.filter((item) => !String(metadataFor(item)?.id || ''));
    const groupsById = new Map();
    legacyItems.forEach((item) => {
      const id = String(metadataFor(item)?.id || '');
      if (!id) return;
      if (!groupsById.has(id)) groupsById.set(id, []);
      groupsById.get(id).push(item);
    });
    const result = { groups: [], orphanGroups: [], invalidGroups: [], invalidItems };
    [...groupsById.entries()].forEach(([groupId, groupedItems]) => {
      const fingerprints = groupedItems.map((item) => legacyFingerprintFor(item, config));
      const kinds = new Set(fingerprints.filter(Boolean).map((fingerprint) => fingerprint.kind));
      if (fingerprints.some((fingerprint) => !fingerprint) || kinds.size !== 1) {
        result.invalidGroups.push({ groupId, items: groupedItems });
        return;
      }
      const kind = [...kinds][0];
      const mains = groupedItems.filter((item, index) => fingerprints[index].role === 'main');
      if (!mains.length) {
        result.orphanGroups.push({ groupId, kind, items: groupedItems });
        return;
      }
      const main = mains.length === 1 ? mains[0] : null;
      const gifts = groupedItems.filter((item, index) => fingerprints[index].role === 'gift');
      const bundles = groupedItems.filter((item, index) => fingerprints[index].role === 'bundle');
      const expectedBundles = legacy.bundleIds?.[kind] || [];
      const exactBundles = bundles.length === expectedBundles.length
        && expectedBundles.every((entry) => bundles.filter((item) => (
          metadataFor(item)?.bundleProduct === entry && linkedToMain(item, main)
        )).length === 1);
      const exactGroup = Boolean(main)
        && gifts.length > 0
        && exactBundles
        && [...gifts, ...bundles].every((item) => linkedToMain(item, main));
      if (exactGroup) {
        result.groups.push({
          groupId,
          kind,
          main,
          gift: gifts[0],
          gifts,
          duplicateGift: gifts.length > 1,
          items: groupedItems
        });
      } else {
        result.invalidGroups.push({ groupId, kind, items: groupedItems });
      }
    });
    return result;
  };
  const classifyCart = (cart, config = {}) => {
    const items = Array.isArray(cart?.items) ? cart.items : [];
    const targetItems = items.filter((item) => metadataFor(item)?.deal === config.deal);
    const groupsById = new Map();
    targetItems.forEach((item) => {
      const id = String(metadataFor(item)?.id || '');
      if (!id) return;
      if (!groupsById.has(id)) groupsById.set(id, []);
      groupsById.get(id).push(item);
    });
    const validGiftKeys = new Set();
    const targetGiftItems = targetItems.filter((item) => (
      ROLES.some((role) => itemMatchesIdentity(item, identityFor(config, role)))
    ));
    const groups = [...groupsById.entries()].flatMap(([groupId, groupedItems]) => {
      const mains = groupedItems.filter((item) => metadataFor(item)?.main === true);
      if (!mains.length) return [];
      const main = mains.length === 1 ? mains[0] : null;
      const kind = kindForMetadata(metadataFor(main), config);
      const giftIds = config.realGiftIds?.[kind] || {};
      const gifts = ROLES.map((role) => groupedItems.find((item) => {
        const metadata = metadataFor(item);
        return itemMatchesIdentity(item, identityFor(config, role))
          && metadata?.gift === giftIds[role];
      })).filter(Boolean);
      const mainValid = Boolean(main)
        && mains.length === 1
        && KINDS.includes(kind)
        && productId(main) === Number(config.qualifyingProductId)
        && Number(main.quantity) === 1
        && lineTotal(main) > 0;
      const giftsValid = gifts.length === ROLES.length
        && new Set(gifts).size === ROLES.length
        && ROLES.every((role) => {
          const identity = identityFor(config, role);
          const gift = gifts.find((item) => itemMatchesIdentity(item, identity));
          const properties = propertiesFor(gift);
          const dog = String(properties[dogProperty()] || '').trim();
          const phone = String(properties[phoneProperty()] || '').trim();
          return Boolean(gift)
            && metadataFor(gift)?.gift === giftIds[role]
            && String(metadataFor(gift)?.id || '') === groupId
            && linkedToMain(gift, main)
            && Number(gift.quantity) === 1
            && lineTotal(gift) === 0
            && originalTotal(gift) > 0
            && (role === 'gift_tags' ? !validationKey({ phone }) : !dog && !phone);
        });
      const complete = validateConfig(config) && mainValid && giftsValid;
      if (complete) gifts.forEach((item) => validGiftKeys.add(item.key));
      return [{ groupId, kind, main, mains, gifts, items: groupedItems, complete }];
    });
    const invalidGiftItems = targetGiftItems.filter((item) => !validGiftKeys.has(item.key));
    const currentMainIds = new Set([...groupsById.entries()].flatMap(([groupId, groupedItems]) => (
      groupedItems.some((item) => metadataFor(item)?.main === true) ? [groupId] : []
    )));
    const orphanGiftItems = targetGiftItems.filter((item) => (
      !currentMainIds.has(String(metadataFor(item)?.id || ''))
    ));
    const legacy = classifyLegacy(items, config);
    return {
      groups,
      legacyGroups: legacy.groups,
      legacyOrphanGroups: legacy.orphanGroups,
      legacyInvalidGroups: legacy.invalidGroups,
      legacyInvalidItems: legacy.invalidItems,
      ordinaryItems: items.filter((item) => !validGiftKeys.has(item.key)),
      invalidGiftItems,
      orphanGiftItems
    };
  };
  const mainContractProperties = () => ({});
  const giftContractProperties = () => ({});

  window.SafeWalkV7KachingNativeContract = Object.freeze({
    KACHING,
    validationKey,
    validateConfig,
    readRootConfig,
    configFromRoot,
    configFromRegistry,
    metadataFor,
    kindForMetadata,
    legacyKindForMetadata,
    classifyCart,
    mainContractProperties,
    giftContractProperties
  });
  window.SafeWalkV6RealGiftContract = window.SafeWalkV7KachingNativeContract;
})();
